module.exports = __webpack_public_path__ + "arrow_red.4809860c.png";